import { useEffect, useState } from 'react';

import { useListViewActions } from '../store';

export const useQueryMoreGenerationResults = (reachedEnd) => {
  const listViewActions = useListViewActions();
  const [shouldQuery, setShouldQuery] = useState(true);

  useEffect(() => {
    if (!reachedEnd) {
      return;
    }

    const results = listViewActions.queryMoreGenerationResults();
    if (results?.[0]?.isGenerating) {
      if (shouldQuery) {
        setTimeout(() => {
          listViewActions.queryMoreGenerationResults();
        }, 500);
      }
    }

    return () => {
      setShouldQuery(false);
    };
  }, [listViewActions, reachedEnd, shouldQuery]);
};
